// extracted by mini-css-extract-plugin
export default {"container":"maGNC9KNleD_mYPmeG1Y","content":"tjRo1FpEz5OyrejN7x9r"};